import * as React from 'react';
import { ButtonTertiary, ButtonPrimary } from 'ui/common';
import { DisplayDate, DisplayText } from 'ui';
import styles from './toggle-button.scss';

export const getButtonText = (value: Date | string | number | undefined, textLabel: string, textLabelToggle: string) =>
  value ? textLabelToggle : textLabel;

export const getValueComponent = (value: Date | string | number | undefined) =>
  (value instanceof Date) ? DisplayDate : DisplayText;

export const getButtonComponent = (value: Date | string | number | undefined) =>
  value ? ButtonTertiary : ButtonPrimary;

export const getCurrentButtonIcon = (
  value: Date | string | number | undefined,
  buttonIcon?: React.ReactNode,
  buttonIconToggle?: React.ReactNode
) => value ? (buttonIconToggle || buttonIcon) : buttonIcon;

export const getSignedStyles = (value: Date | string | number | undefined) => value ? styles.signed : '';

export const getValidationErrorStyle = (validation: any) => (validation && !!validation.messages.length) ? styles.validationError : '';

export const SecondaryValueText: React.FC<{
  show: boolean;
  text?: React.ReactNode;
}> = ({ show, text }) => show && text ? <div className={styles.secondaryValueText}>{text}</div> : null;

interface ToggleActionButtonProps {
  value: Date | string | number | undefined;
  componentId: string;
  className?: string;
  readOnly?: boolean;
  hideUndoEgress?: boolean;
  iconOnlyWhenActive?: boolean;
  buttonText: string;
  icon?: React.ReactNode;
  onClick: () => void;
}

export const ToggleActionButton: React.FC<ToggleActionButtonProps> = props => {
  const { value, hideUndoEgress, iconOnlyWhenActive, buttonText, icon } = props;

  if (hideUndoEgress && !!value) {
    return null;
  }

  const ButtonComponent: any = getButtonComponent(value);
  const hideText = !!iconOnlyWhenActive && !!value;

  return (
    <ButtonComponent
      componentId={`${props.componentId}_button`}
      className={props.className}
      disabled={props.readOnly}
      onClick={props.onClick}
      textClose={hideText ? buttonText : undefined}
    >
      {icon}{icon && !hideText ? ' ' : ''}{!hideText && buttonText}
    </ButtonComponent>
  );
};
